<div class="select-search" (click)="$event.stopPropagation()">
  <div class="select-search__field">
    <input
      #searchInput
      type="text"
      class="select-search__input"
      autocomplete="off"
      [attr.aria-label]="placeholder"
      [placeholder]="placeholder"
      [value]="query"
      (input)="onInput($event)"
      (keydown)="onKeydown($event)"
    />
    <button
      *ngIf="query"
      type="button"
      class="select-search__clear"
      aria-label="Clear search"
      (click)="clear()"
    >
      &times;
    </button>
    <span *ngIf="!query" class="select-search__icon" aria-hidden="true">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.333 12.667A5.333 5.333 0 1 0 7.333 2a5.333 5.333 0 0 0 0 10.667ZM14 14l-2.9-2.9"
          stroke="#98A2B3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </div>
</div>
